<template>
  <!-- 东平县疾病预防控制中心 -->
  <div class="pageContent">
    <div class="hosName">东平县疾病预防控制中心</div>
    <div class="ourterTitle">
      姓名/检查号绑定数字影像
    </div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="value27100009.name27100009"
          placeholder="请输入姓名"
        />
      </div>
      <div class="IDNumber">
        <van-field
          v-model="value27100009.value1"
          clearable
          placeholder="请选择就诊时间"
          @focus="showPopup"
        />
        <van-popup v-model="show" class="van-Date">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            @confirm="onConfirm"
            @cancel="onCancel"
          />
        </van-popup>
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      value27100009: {
        name27100009: "",
        value1: ""
      },
      rules: true,
      show: false,
      currentDate: new Date()
    };
  },
  watch: {
    value27100009:{
      handler: function(newVal, oldVal) {
        if (newVal.name27100009 != "" && newVal.value1 != "") {
          this.rules = false;
        } else {
          this.rules = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    showPopup() {
      this.show = true
    },
    onCancel() {
      this.show = false
    },
    onConfirm(value) {
      let date = value
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      this.value27100009.value1 = date.getFullYear() + '' + month + '' + strDate
      this.show = false
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value27100009", JSON.stringify(this.value27100009));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    let value27100009 = JSON.parse(window.localStorage.getItem("value27100009"))
    if (value27100009.value1 != "" && value27100009.name27100009 != "") {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.hosName {
  font-size: 30px;
  padding: 65px 0 5px;
  color: rgb(164, 25, 16);
}
.ourterTitle {
  padding: 0 0 20px;
  font-size: 12px;
  color: rgb(51, 62, 80)
}
.bindDetails {
  width: 90%;
  margin: 0 auto;
}
</style>
